<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Catalogue</li>
        <li class="breadcrumb-item active">Products</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="caption">
          <h6>Products list</h6>
        </div>
        <div class="actions">
          <router-link
            v-if="$store.state.permissions.create.catalogue_products"
            :to="{ name: 'catalogue-product-create' }"
            class="btn btn-success"
          >Create new product</router-link>
        </div>
      </div>
      <div class="card-body">
        <div v-if="$store.state.permissions.see.catalogue_products" class="row">
          <div class="col-xl-12">
            <vue-bootstrap4-table ref="ProductList" :rows="products" :columns="columns" :config="config" :total-rows="total_rows" @on-change-query="onChangeQuery" @on-select-row="rowClicked">
              <template slot="sort-asc-icon">
                <i class="icon-im icon-im-sort-alpha-asc"/>
              </template>
              <template slot="sort-desc-icon">
                <i class="icon-im icon-im-sort-alpha-desc"/>
              </template>
              <template slot="no-sort-icon">
                <i class="icon-im icon-im-menu2"/>
              </template>
              <template slot="active--col" slot-scope="props">
                <span v-tooltip.top-center="'Mark as inactive'" v-if="props.row.active" class="btn btn-xs btn-success btn-switch" @click.stop="switchActive(props.row.id)">Active</span>
                <span v-tooltip.top-center="'Mark as active'" v-else class="btn btn-xs btn-danger btn-switch" @click.stop="switchActive(props.row.id)">Inactive</span>
              </template>
              <template slot="actions" slot-scope="props">
                <router-link
                  v-if="$store.state.permissions.edit.catalogue_categories"
                  :to="{ name: 'catalogue-product-edit', params: { productId: props.row.id } }"
                  @click.stop="() => true"
                >
                  <i v-tooltip.top-center="'Edit'" class="icon-im icon-im-pencil" />
                </router-link>
                <i
                  v-tooltip.top-center="'Delete'"
                  v-if="$store.state.permissions.delete.catalogue_categories"
                  class="icon-im icon-im-bin delete--link"
                  @click.stop="deleteProduct(props.row.id)"
                />
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
        <div v-else>
          <h3>You have not permission for do that</h3>
        </div>
      </div>
    </div>
    <sweet-modal ref="delete_confirm" hide-close-button blocking title="Confirm delete">
      Confirm delete catalogue product
      <button
        slot="button"
        type="button"
        class="btn btn-primary"
        @click="cancelDelete()"
      >Cancel</button>
      <button slot="button" type="button" class="btn btn-danger" @click="deleteProduct()">Confirm</button>
    </sweet-modal>
  </div>
</template>

<script>
/* global axios, toastr */
import { SweetModal } from 'sweet-modal-vue'
export default {
  name: 'CatalogueProductsList',
  components: {
    SweetModal
  },
  data () {
    return {
      products: [],
      columns: [
        {
          label: '#',
          name: 'id',
          sort: true,
          uniqueId: true
        },
        {
          label: 'Name',
          name: 'title',
          sort: true,
          initial_sort: true,
          initial_sort_order: 'asc'
        },
        {
          label: 'Active',
          name: 'active',
          slot_name: 'active--col',
          filter: {
            type: 'select',
            mode: 'multi',
            closeDropdownOnSelection: true,
            placeholder: 'Select status',
            options: [
              {
                'name': 'Active',
                'value': '1'
              },
              {
                'name': 'Inactive',
                'value': '0'
              }
            ],
            select_all_checkbox: {
              visibility: true,
              text: 'Select all'
            },
            init: {
              value: [0, 1]
            }
          }
        },
        {
          label: 'Categories',
          name: 'categories'
        },
        {
          label: 'Actions',
          slot_name: 'actions'
        }
      ],
      config: {
        card_mode: false,
        checkbox_rows: true,
        server_mode: true,
        loaderText: 'Updating...',
        show_refresh_button: false,
        show_reset_button: false,
        global_search: {
          visibility: false
        },
        per_page_options: [10, 50, 100]
      },
      queryParams: {
        sort: [],
        filters: [],
        global_search: '',
        per_page: 10,
        page: 1
      },
      total_rows: 0,
      productForDelete: null,
      dropdowns: []
    }
  },
  mounted () {
    this.enableDropdowns()
  },
  updated () {
    this.enableDropdowns()
  },
  destroyed () {
    this.dropdowns.forEach(($dropdown) => {
      document.removeEventListener('click', $dropdown.clickOutsideEvent)
    })
  },
  methods: {
    onChangeQuery (queryParams) {
      this.queryParams = queryParams
      this.fetchData()
    },
    deleteProduct (id) {
      let that = this
      if (this.productForDelete) {
        axios
          .delete('/api/admin/catalogue/products/' + this.productForDelete)
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              that.fetchData()
              that.productForDelete = null
              toastr['success']('Product has been deleted successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
              that.productForDelete = null
            }
          })
          .catch(error => {
            console.log(error)
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
        this.$refs.delete_confirm.close()
      } else {
        this.productForDelete = id
        this.$refs.delete_confirm.open()
      }
    },
    cancelDelete () {
      this.productForDelete = null
      this.$refs.delete_confirm.close()
    },
    rowClicked (rowId) {
      if (rowId) {
        this.$router.push('/admin/catalogue/products/' + rowId + '/edit')
      }
    },
    switchActive (id) {
      let that = this
      axios
        .post('/api/admin/catalogue/products/' + id + '/switch')
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            that.fetchData()
            that.productForDelete = null
            toastr['success']('Status has been changed successfully')
          } else {
            let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
            toastr['error'](message)
            that.productForDelete = null
          }
        })
        .catch(error => {
          console.log(error)
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    },
    fetchData () {
      let that = this
      axios.post('/api/admin/catalogue/products', {
        per_page: this.queryParams.per_page,
        page: this.queryParams.page,
        filter: this.queryParams.filters,
        sort: this.queryParams.sort
      })
        .then(function (response) {
          that.products = response.data.products
          that.total_rows = response.data.total
          that.$nextTick(() => {
            that.addRowClickListener()
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addRowClickListener () {
      let that = this
      let rows = this.$refs.ProductList.$el.querySelectorAll('tbody tr:not(.table-active):not(.footer-pagination-row) td')
      rows.forEach((item) => {
        item.addEventListener('click', (event) => {
          if (event && event.target) {
            let row = event.target.parentElement
            if (row) {
              that.rowClicked(row.getAttribute('data-id'))
            }
          }
        })
      })
    },
    enableDropdowns () {
      this.$el.querySelectorAll('[data-toggle="dropdown"]').forEach(($dropdownToggle) => {
        const $dropdown = $dropdownToggle.nextElementSibling
        console.log($dropdown)
        let isShown = false

        function setIsShown (state) {
          isShown = state
          $dropdown.classList.toggle('show', isShown)
        }

        if (!this.dropdowns.includes($dropdown)) {
          console.log('add', $dropdownToggle)
          this.dropdowns.push($dropdown)

          $dropdownToggle.addEventListener('click', (event) => {
            console.log('open')
            event.preventDefault()
            setIsShown(!isShown)
          })

          $dropdown.addEventListener('click', (event) => {
            console.log('close')
            event.preventDefault()
            setIsShown(false)
          })

          $dropdown.clickOutsideEvent = (event) => {
            const isDropdownOrChildren = $dropdown === event.target || $dropdown.contains(event.target)
            const isDropdownToggleOrChildren = $dropdownToggle === event.target || $dropdownToggle.contains(event.target)

            if (!isDropdownOrChildren && !isDropdownToggleOrChildren) {
              setIsShown(false)
            }
          }
          document.addEventListener('click', $dropdown.clickOutsideEvent)
        }
      })
    }
  }
}
</script>

<style>
.delete--link:hover {
  cursor: pointer;
}
</style>
